import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { oauthConfig } from '../model/auth.model';


@Injectable({
  providedIn: 'root'
})

export class AuthService {
  claims!: Record<string, any>

  constructor(private readonly oauthService: OAuthService) {
    this.oauthService.setStorage(localStorage);
  }

  authorize() {
    this.oauthService.configure(oauthConfig);
    this.oauthService.loadDiscoveryDocumentAndLogin();
  }

  getAccessToken() {
    return this.oauthService.getAccessToken();
  }

  hasValidAccessToken() {
    return this.oauthService.hasValidAccessToken();
  }

  private extract(property: string): string {
    this.claims = this.oauthService.getIdentityClaims()
    if (this.claims == null) {
      return '';
    }
    return this.claims[property]
  }
  get upn() {
    return this.extract('upn');
  }
  get email() {
    return this.extract('email');
  }
  isAuthorized() {
    return this.oauthService.hasValidAccessToken();
  }

}
